const dopuszczalnaLadownosc = {
    t: 'Dopuszczalna ładowność',
    name: 'dopuszczalna-ladownosc',
    type: 'number',
    unit: 'kg'
}

export default dopuszczalnaLadownosc